const React = require('react')
const PropTypes = require('prop-types')
const styles = require('./dropdown.css')
const Link = require('@npm/spiferack/link')

class SearchFilterDropdown extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      dropdownText: this.props.text,
    }
  }

  changeDropdownText = text => {
    this.setState({dropdownText: text})
  }

  render() {
    const {heading, searchWord, sortByOption} = this.props
    const {dropdownText} = this.state
    const dropdownContent = [
      {
        key: 'downloaded',
        labelText: 'Most Downloaded',
        onChange: () => this.setState({dropdownText: 'Most Downloaded'}),
        idx: 0,
        queryParam: 'downloadCount',
      },
      {
        key: 'dependents',
        labelText: 'Most Dependents',
        onChange: () => this.setState({dropdownText: 'Most Dependents'}),
        idx: -1,
        queryParam: 'dependentCount',
      },
      {
        key: 'published',
        labelText: 'Recently Published',
        onChange: () => this.setState({dropdownText: 'Recently Published'}),
        idx: -2,
        queryParam: 'recentlyPublished',
      },
    ]

    if (sortByOption) {
      const selectedOption = dropdownContent.find(item => item.queryParam === sortByOption)
      if (selectedOption) {
        this.changeDropdownText(selectedOption.labelText)
      }
    }

    return (
      <div className={styles.searchFilterDropdown}>
        <input className={styles.dropdownToggle} type="text" />
        <div className={styles.searchFilterDropdownText}>{dropdownText}</div>
        <ul className={styles.dropdownContent}>
          {heading && (
            <li>
              <span className={styles.header}>{heading}</span>
            </li>
          )}
          {dropdownContent.map(item => (
            <li key={item.key}>
              <div role="button" tabIndex={item.idx} onClick={item.onChange} onKeyDown={item.onChange} key={item.key}>
                <Link>
                  <a href={`/search?q=${searchWord}&sortBy=${item.queryParam}&pqm=false`}>{item.labelText}</a>
                </Link>
              </div>
            </li>
          ))}
        </ul>
      </div>
    )
  }
}

SearchFilterDropdown.propTypes = {
  text: PropTypes.string,
  heading: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      href: PropTypes.string,
      icon: PropTypes.node,
    }),
  ),
  onClick: PropTypes.func,
}

module.exports = SearchFilterDropdown
